var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-file-item"},[_c('a',{attrs:{"href":_vm.img,"target":"_blank"}},[_c('a-icon',{staticClass:"close",attrs:{"type":"close"},on:{"click":_vm.closeHandler}}),_c('img',{attrs:{"src":_vm.img,"alt":"..."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }